import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { ChatView } from '@/features/chat/ChatView';
import { DashPage } from '@/features/dash/DashPage';
import { AnomalyGuidePage } from '@/features/dash/AnomalyGuidePage';
import { SupportView } from '@/features/support/SupportView';
import { ReportGeneratorPage } from '@/features/reports/ReportGeneratorPage';
import { ReportGuidePage } from '@/features/reports/ReportGuidePage';
import { LoginView } from '@/features/auth/LoginView';
import { SignupView } from '@/features/auth/SignupView';
import { VerifyOtpView } from '@/features/auth/VerifyOtpView';
import { LanguageProvider } from '@/i18n/LanguageContext';
import { RequireAuth } from '@/components/auth/RequireAuth';

const AppRoutes: React.FC = () => (
  <div className="min-h-screen bg-light-blue-50">
    <Routes>
        <Route
          path="/"
          element={
            <RequireAuth>
              <ChatView />
            </RequireAuth>
          }
        />
        <Route path="/embed" element={<ChatView publicMode embedMode />} />
        <Route path="/embed/report-generator" element={<ReportGeneratorPage publicMode embedMode />} />
        <Route path="/embed/report-generator/guide" element={<ReportGuidePage publicMode />} />
        <Route path="/embed/support" element={<SupportView publicMode />} />
        <Route path="/embed/anomalies" element={<DashPage publicMode />} />
        <Route path="/embed/anomalies/guide" element={<AnomalyGuidePage publicMode />} />
        <Route
          path="/anomalies"
          element={
            <RequireAuth>
              <DashPage />
            </RequireAuth>
          }
        />
        <Route
          path="/anomalies/guide"
          element={
            <RequireAuth>
              <AnomalyGuidePage />
            </RequireAuth>
          }
        />
        <Route  
          path="/support"
          element={
            <RequireAuth>
              <SupportView />
            </RequireAuth>
          }
        />
        <Route  
          path="/report-generator"
          element={
            <RequireAuth>
              <ReportGeneratorPage />
            </RequireAuth>
          }
        />
        <Route
          path="/report-generator/guide"
          element={
            <RequireAuth>
              <ReportGuidePage />
            </RequireAuth>
          }
        />
        <Route path="/data-quality" element={<DashPage />} />
        <Route path="/login" element={<LoginView />} />
        <Route path="/signup" element={<SignupView />} />
        <Route path="/verify-otp" element={<VerifyOtpView />} />
    </Routes>
  </div>
);

const App: React.FC = () => (
  <LanguageProvider>
    <AppRoutes />
  </LanguageProvider>
);

export default App;
